(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mb-brief-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mb-brief-disclosures')) {
    customElements.define('mb-brief-disclosures', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.sync = () => this.querySelectorAll('.mb-brief__details').forEach(detail => { detail.open = !this.media.matches; });
        this.sync();
        this.media.addEventListener('change', this.sync);
      }
      disconnectedCallback() { this.media.removeEventListener('change', this.sync); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-emotion-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    function init(root) {
      root.querySelectorAll('[data-mb-emo]').forEach(function (stage) {
        if (stage.dataset.mbEmoReady) return;
        stage.dataset.mbEmoReady = '1';
        var video = stage.querySelector('[data-mb-emo-video]');
        if (!video) return;
        var src = video.getAttribute('data-src');
        if (!src) return;

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            if (!video.src) {
              video.src = src;
              video.addEventListener('playing', function () { video.classList.add('is-playing'); }, { once: true });
            }
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
            io.unobserve(stage);
          });
        }, { threshold: 0.2 });
        io.observe(stage);
      });
    }

    if (document.readyState !== 'loading') init(document);
    else document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-etapes-hiw"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function init(root) {
      root.querySelectorAll('.mb-hiw').forEach(function (sec) {
        if (sec.dataset.mbHiwReady) return;
        sec.dataset.mbHiwReady = '1';
        sec.classList.add('mb-hiw--anim');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
        io.observe(sec);
      });
    }

    if (document.readyState !== 'loading') init(document);
    else document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-jeu-universel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function init(root) {
      root.querySelectorAll('.mb-jeu').forEach(function (sec) {
        if (sec.dataset.mbJeuReady) return;
        sec.dataset.mbJeuReady = '1';
        sec.style.setProperty('--mb-jeu-n', sec.querySelectorAll('.mb-jeu__step').length);
        sec.classList.add('mb-jeu--anim');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
        io.observe(sec);
      });
    }

    if (document.readyState !== 'loading') init(document);
    else document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-metier-moment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function init(root) {
      root.querySelectorAll('.mb-moment').forEach(function (sec) {
        if (sec.dataset.mbMomentReady) return;
        sec.dataset.mbMomentReady = '1';
        sec.classList.add('mb-moment--anim');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
        io.observe(sec);
      });
    }

    if (document.readyState !== 'loading') init(document);
    else document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-sector-carousel"] && !Shopify.designMode) return;
  try {
    
  function initMbSectorCarousels(root) {
    (root || document).querySelectorAll('[data-mb-sector-carousel]').forEach(function (section) {
      if (section.dataset.mbSectorReady) return;
      section.dataset.mbSectorReady = 'true';
      var track = section.querySelector('[data-mb-sector-track]');
      var prev = section.querySelector('[data-mb-sector-prev]');
      var next = section.querySelector('[data-mb-sector-next]');
      var count = section.querySelector('[data-mb-sector-count]');
      if (!track || !prev || !next) return;
      var cards = Array.from(track.children);
      var update = function () {
        var limit = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft >= limit - 3;
        var closest = 0;
        cards.forEach(function (card, index) {
          if (Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft) < Math.abs(cards[closest].offsetLeft - track.offsetLeft - track.scrollLeft)) closest = index;
        });
        if (count) count.textContent = String(closest + 1).padStart(2, '0') + ' / ' + String(cards.length).padStart(2, '0');
      };
      var move = function (direction) {
        var step = cards[0] ? cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
        track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initMbSectorCarousels(document); });
  else initMbSectorCarousels(document);
  document.addEventListener('shopify:section:load', function (event) { initMbSectorCarousels(event.target); });

  } catch(e) { console.error(e); }
})();
})();
